import { ReactNode } from 'react';

import { ButtonProps } from '@chakra-ui/react';

import { CustomTooltipStyles } from 'components/DataDisplay';

export const TimeRange = {
  W1: '1W',
  M1: '1M',
  M3: '3M',
  M12: '12M',
  Y1: '1Y',
};

export interface OptionItem {
  label: string;
  value: any;
  key?: string;
  isDisabled?: boolean;
}

export interface PrimaryButtonProps extends ButtonProps {
  tooltip?: string | ReactNode;
  iconSize?: number | string;
  showGrayBg?: boolean;
  tooltipStyles?: CustomTooltipStyles;
  iconColor?: string;
}
